function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#E1E9F0",
  d: "M52.343 5l-2 2H5a3 3 0 00-3 3v16a3 3 0 003 3h23.343l-2 2H5a5 5 0 01-5-5V10a5 5 0 015-5h47.343zm11.314 0H85a5 5 0 015 5v16a5 5 0 01-5 5H37.657l2-2H85a3 3 0 003-3V10a3 3 0 00-3-3H61.657l2-2zM18.49 13.374a3.154 3.154 0 012.283-.98c1.188 0 2.225.663 2.777 1.646a3.838 3.838 0 011.57-.333c2.143 0 3.88 1.753 3.88 3.915s-1.737 3.915-3.88 3.915c-.257 0-.513-.026-.765-.077a2.836 2.836 0 01-3.717 1.168 3.237 3.237 0 01-6.017-.147 2.97 2.97 0 01-.617.065c-1.66 0-3.005-1.36-3.005-3.036a3.04 3.04 0 011.502-2.63A3.494 3.494 0 0115.711 12c1.134 0 2.141.539 2.78 1.374zM62.678 1.737l-33.941 33.94-1.415-1.414L61.263.323l1.415 1.414z"
});

var SvgDisabled = function SvgDisabled(props) {
  return React.createElement("svg", _extends({
    width: 90,
    height: 36,
    viewBox: "0 0 90 36"
  }, props), _ref);
};

export default SvgDisabled;